// Screening API endpoints

export const screenPepUrl = (): string => {
  return `/kyc/screen-pep`;
};
export const screeningCardUrl = (businessKey: string): string => {
  return `/screen/${businessKey}/verify-card`;
};

export const screeningPassportUrl = (businessKey: string): string => {
  return `/screen/${businessKey}/verify-passport`;
};

export const screeningStartUrl = (businessKey: string): string => {
  return `/screen/${businessKey}/start`;
};

export const screeningResultUrl = (businessKey: string): string => {
  return `/screen/${businessKey}/result`;
};

export const screeningHistoryUrl = (businessKey: string): string => {
  return `/screen/${businessKey}/history`;
};

export const getScreeningReportDownloadUrl = (filename: string): string =>
  `/screening/reports/download/${filename}`;